import {path} from '@acng/frontend-voyager';
import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';

import {userRoute} from 'acng/userPool/config/routes';
import {mainView} from 'acng/layout/service/sequence.js';
import {feature} from './template.js';

if (!feature[HIDDEN]) {
  userRoute.create(path('/achievements'), mainView(feature, 'achievements'));
}
